import React from 'react';
import { Formik, Form } from 'formik';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Title from 'shared/components/title/Title';
import confirmDiscardChanges from 'shared/components/confirm-discard-changes/confirmDiscardChanges';
import CheckBox from 'shared/components/check-box/CheckBox';
import NutritionItem from 'features/nutrition/components/NutritionItem';
import { roundNum } from 'utils/numbers';
import { connect } from 'react-redux';
import { getClient } from 'features/clientProfile/ducks/clientProfileActions';
import {
  getTrainerNutritionPlans,
  assignClientToPlans
} from 'features/nutrition/ducks/nutritionActions';
import Loader from 'features/Loader/Loader';

class NutritionAssign extends React.Component {
  constructor(props) {
    super(props);
    this.clientId = this.props.match.params.client_id;
  }

  componentDidMount() {
    this.props.getClient(this.clientId, this.props.history);
    this.props.getNutritionPlans();
  }

  render() {
    const {
      client,
      plans,
      history,
      assignClientToPlans,
      loadingClient,
      nutrationLoadingState
    } = this.props;
    plans &&
      plans.sort((plan1, plan2) => {
        return plan1.name >= plan2.name ? 1 : -1;
      });

    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          plans_id: []
        }}
        onSubmit={values => {
          return (
            client &&
            values.plans_id.length &&
            assignClientToPlans(client, values.plans_id, history)
          );
        }}
      >
        {formik => (
          <Form>
            {formik.isSubmitting || loadingClient || nutrationLoadingState ? (
              <Loader />
            ) : (
              <div className="client-form-pages">
                <div className="container">
                  <Breadcrumb>
                    <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                    <Breadcrumb.Item href={`/clients/${client?.id}`}>
                      {`${client?.first_name} ${client?.last_name}`}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>
                      Assign Nutrition Plan
                    </Breadcrumb.Item>
                  </Breadcrumb>
                  <Title
                    pageTitle="Assign Nutrition Plan"
                    linkText="Cancel"
                    buttonText="Save"
                    cancelLink={`/clients/${client?.id}`}
                    cancelBtn={
                      formik.dirty &&
                      (() =>
                        confirmDiscardChanges(
                          `/clients/${client?.id}`,
                          history
                        ))
                    }
                    disabled={!formik.values.plans_id.length}
                  />
                  <div className="assign-page">
                    <ul className="grid-list">
                      {plans &&
                        client &&
                        plans.map(plan => {
                          return !plan.clients_id.includes(client.id) ? (
                            <li key={plan.id}>
                              <CheckBox
                                key={plan.id}
                                value={plan.id}
                                id={plan.id}
                                name="plans_id"
                              />
                              <NutritionItem
                                title={plan.name}
                                desc={`${roundNum(
                                  plan.meals_count
                                )} Meals, ${roundNum(
                                  plan.snacks_count
                                )} Snacks, ${roundNum(
                                  plan.total_calories
                                )} Cal`}
                                LinkTo={`/nutrition/${plan.id}`}
                              />
                            </li>
                          ) : null;
                        })}
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    loadingClient: state.clientProfileReducer.loading,
    plans: state.nutritionReducer.trainerNutrition.plans,
    nutrationLoadingState:
      state.nutritionReducer.trainerNutrition.nutrationLoadingState
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getNutritionPlans: () => dispatch(getTrainerNutritionPlans()),
    assignClientToPlans: (client, plansId, history) =>
      dispatch(assignClientToPlans(client, plansId, history))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NutritionAssign);
